import comments from './commentsReducer'
import currentProtip from './currentProtipReducer'
import currentUser from './currentUserReducer'
import hearts from './heartsReducer'
import job from './jobReducer'
import protips from './protipsReducer'
import topicFollows from './topicFollowsReducer'
import userFollows from './userFollowsReducer'

export default {
  comments,
  currentProtip,
  currentUser,
  hearts,
  job,
  protips,
  topicFollows,
  userFollows,
}
